import { createTheme } from "@mui/material/styles";

 const playlanTheme=createTheme({

 	palette: {
   		 mode: 'dark',
    	primary: {
      		main: '#27B0FE',
      		contrastText: '#ffebee',
    	},
      secondary:{
          main:'#26125D' ,
          contrastText:'#ffebee',
      }
  },
    typography: {
      fontFamily: ['Poppins', 'sans-serif'].join(","),
      fontSize: 10,

    }

 });

 let themeModules={
  background:"#050505",
  panel:"#1E1E1E"}


 export  {playlanTheme,themeModules }